
jQuery( function( $ ) {
    const shopAsClientRoleField = document.getElementById( 'nuwoo_customer_role_field' );
    const shopAsClientRole = document.getElementById( 'nuwoo_customer_role' );
    const shopAsClientSelect = document.getElementById( 'billing_shop_as_client' );
    if ( !shopAsClientSelect || !shopAsClientRoleField ) return;

    shopAsClientSelect.addEventListener( 'change', ( e ) => {
        const select = e.currentTarget;
        const shouldShopAsClient = select.value === 'yes';

        shopAsClientRoleField.classList.toggle( 'hidden', !shouldShopAsClient );
        shopAsClientRole?.toggleAttribute( 'disabled', !shouldShopAsClient );
    } );
} );
